<template>
  <div class="store_blocks">
    <div class="selected_store">
      {{ $AllStores[storeId]?.short_title }}: <strong>{{ storeStatus[storeId] ?? 0 }}</strong>
    </div>
    <div v-for="(storeId, index) in ($StoreRelations[storeId] ?? [])">
      {{ $AllStores[storeId]?.short_title }}: <strong>{{ storeStatus[storeId] ?? 0 }}</strong>
    </div>
  </div>
</template>

<script>

export default {
  props: ['storeStatus', 'storeId'],
  computed: {
    $StoreRelations() {
      return this.$store.getters['platform/storeRelations']
    },
    $AllStores() {
      return this.$store.getters['platform/stores']
    },
  },
}

</script>

<style scoped>
.store_blocks div.extra_store_div {
  border: 4px solid #5bbfde;
  margin-left: auto;
}

.store_blocks {
  display: flex;
  flex-wrap: wrap;
}

.store_blocks .selected_store {
  border: 3px solid gray;
}

.store_blocks div {
  padding: 0 5px;
  border: 2px solid lightgray;
  margin-right: 3px;
}
</style>
